export { default } from './AddressInput';
export type {
  AddressInputProps,
  AutoCompletePrediction,
  SelectedAddress,
  AddressValidationResult,
} from './AddressInput';
